import React from 'react';
import { css } from '@emotion/css';

import { useGetBenefitsList } from '../../../customHooks/useGetBenefitsList.hook';
import { BenefitsListPage } from '../../../@types/benefitsListPage';
import { useGetBenefitsListPage } from '../../../customHooks/useGetBenefitsListPage.hook';
import { LoadingBenefitPageContent } from '../../common/display/loader/LoadingBenefitPageContent';
import { IssuePage } from '../issuePage/IssuePage';
import { IssueType } from '../../../@types/issueType';
import { BenefitPageState } from '../../../@types/benefitPageState';
import { BenefitsProvider } from '../benefits/BenefitsContext';
import { BenefitsList } from '../benefits/benefitsList/BenefitsList';

import { BenefitsModals } from '../benefits/modals/BenefitsModals';
import { LivingPlusBanner } from '../livingPlusBanner/LivingPlusBanner';
import { MembershipManagement } from '../MembershipManagement/MembershipManagement';
import WelcomeModal from '../welcomeModal/WelcomeModal';
import { FAQ } from '../faq/FAQ';

const styles = {
  membershipArea: {
    width: '50% !important',
    '@media (max-width: 481px)': { width: '100% !important' },
    '@media (min-width: 669px) and (max-width: 779px)': { width: '100% !important' },
  },
};

export const ContentArea = ({ benefitPageState }: { benefitPageState: BenefitPageState }) => {
  const benefitsList = useGetBenefitsList();
  const benefitsPageListPage = useGetBenefitsListPage();
  const isKaeuferPlusPage = benefitsPageListPage === BenefitsListPage.KauferPlus;
  if (benefitPageState === BenefitPageState.LOADING) {
    return <LoadingBenefitPageContent />;
  }

  if (benefitPageState === BenefitPageState.ERROR) {
    return <IssuePage type={IssueType.BENEFIT_PAGE_ERROR} />;
  }

  return (
    <>
      <BenefitsProvider>
        <BenefitsList benefits={benefitsList} />
        <BenefitsModals />
        {!isKaeuferPlusPage && <LivingPlusBanner />}
        <WelcomeModal />
      </BenefitsProvider>
      <div className='grid grid-flex gutter-m margin-top-xxl palm-padding-top-m'>
        <div className={`grid-item padding-bottom-s margin-bottom-xxl ${css(styles.membershipArea)}`}>
          <MembershipManagement />
        </div>
        <div className={`grid-item ${css(styles.membershipArea)}`}>
          <FAQ />
        </div>
      </div>
    </>
  );
};
